import React, { useState, useEffect } from "react";
import "./DepositUpi.css";
import UpiGetway from "./UpiGetway";
// import "animate.css";
import { IoChevronBackSharp } from "react-icons/io5";
import {
  __,
  addNewStyle,
  CRISTP_ID,
  decode,
  defaultAvatar,
  encode,
  getUID,
  sendNotfication,
  toUSD,
  wait,
} from "../../../Helper";
import axios from "axios";
import Cookies from "js-cookie";
import { QRCodeCanvas } from "qrcode.react";
import UsdtGateway from "./UsdtGateway";
import CopyableInput from "./CopyableInput";

function DepositUpi({ style, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Deposit");
  const [showDropdowns, setShowDropdowns] = useState({});
  const [upiGatewayVisible, setUpiGatewayVisible] = useState(false);
  const [usdtGatewayVisible, setUsdtGatewayVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  // Payment Method Selection State
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState("manual");

  // Manual Deposit States
  const [manualDepositExpanded, setManualDepositExpanded] = useState(false);
  const [showManualPaymentForm, setShowManualPaymentForm] = useState(false);
  const [amount, setAmount] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // QR Manual Deposit States
  const [utrNumber, setUtrNumber] = useState("");
  const [depositPaymentSetting, setDepositPaymentSetting] = useState({});
  const [step, setStep] = useState(1);
  const [depositType, setDepositType] = useState("automatic");
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState(null);

  // Automatic Payment States (from OnlineDeposit)
  const [showAutomaticPaymentForm, setShowAutomaticPaymentForm] =
    useState(false); // Changed to false initially
  const [automaticAmount, setAutomaticAmount] = useState("");
  const [automaticUtrNumber, setAutomaticUtrNumber] = useState("");
  const [automaticErrorMessage, setAutomaticErrorMessage] = useState("");
  const [mobile, setMobile] = useState("");
  const [orderId, setOrderId] = useState("");
  const [isVerifyPayment, setIsVerifyPayment] = useState(false);
  const [payLink, setPayLink] = useState("");

  // USDT Payment States
  const [showUsdtPaymentForm, setShowUsdtPaymentForm] = useState(false);
  const [usdtAmount, setUsdtAmount] = useState("");
  const [usdtErrorMessage, setUsdtErrorMessage] = useState("");

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(
          "https://api.betbazaar365.com/setting",
          {
            params: { uid: parseFloat(Cookies.get("uid")) },
          }
        );

        const data = response?.data;

        if (data) {
          setSettings(data?.data[0]);
        }
      } catch (error) {
        console.error("Error fetching payment settings:", error);
      }
    };

    fetchSettings();
  }, []);

  // New useEffect to handle payment form visibility when popup opens
  useEffect(() => {
    if (isOpen && selectedPaymentMethod === "manual") {
      setShowAutomaticPaymentForm(true);
    } else if (isOpen && selectedPaymentMethod === "usdt") {
      setShowUsdtPaymentForm(true);
    }
  }, [isOpen, selectedPaymentMethod]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setIsClosing(false);
      // Reset all states when main popup closes
      setSelectedPaymentMethod("automatic");
      setManualDepositExpanded(false);
      setShowManualPaymentForm(false);
      setShowAutomaticPaymentForm(false);
      setShowUsdtPaymentForm(false);
      setAmount("");
      setAutomaticAmount("");
      setUsdtAmount("");
      setErrorMessage("");
      setUtrNumber("");
      setAutomaticUtrNumber("");
      setUsdtErrorMessage("");
      setMobile("");
      setOrderId("");
      setIsVerifyPayment(false);
      setPayLink("");
    }, 500);
  };

  const handleAutomaticPaymentClick = () => {
    setSelectedPaymentMethod("automatic");
    setManualDepositExpanded(false);
    setShowManualPaymentForm(false);
    setShowUsdtPaymentForm(false);
    setShowAutomaticPaymentForm(true);
    setAmount("");
    setErrorMessage("");
    setUtrNumber("");
    // Reset automatic payment states
    setAutomaticAmount("");
    setAutomaticUtrNumber("");
    setAutomaticErrorMessage("");
    setMobile("");
    setIsVerifyPayment(false);
    setPayLink("");
    // Reset USDT states
    setUsdtAmount("");
    setUsdtErrorMessage("");
  };

  const handleManualDepositToggle = () => {
    setSelectedPaymentMethod("manual");
    setShowAutomaticPaymentForm(false);
    setShowUsdtPaymentForm(false);
    setManualDepositExpanded(!manualDepositExpanded);
    if (!manualDepositExpanded) {
      setShowManualPaymentForm(false);
      setAmount("");
      setErrorMessage("");
      setUtrNumber("");
    }
    // Reset automatic payment states
    setAutomaticAmount("");
    setAutomaticUtrNumber("");
    setAutomaticErrorMessage("");
    setMobile("");
    setIsVerifyPayment(false);
    setPayLink("");
    // Reset USDT states
    setUsdtAmount("");
    setUsdtErrorMessage("");
  };

  // USDT Payment Handler
  const handleUsdtPaymentClick = () => {
    setSelectedPaymentMethod("usdt");
    setShowAutomaticPaymentForm(false);
    setManualDepositExpanded(false);
    setShowManualPaymentForm(false);
    setShowUsdtPaymentForm(true);
    // Reset all states
    setAmount("");
    setAutomaticAmount("");
    setErrorMessage("");
    setUtrNumber("");
    setAutomaticUtrNumber("");
    setAutomaticErrorMessage("");
    setMobile("");
    setIsVerifyPayment(false);
    setPayLink("");
  };

  // Automatic Payment Functions (from OnlineDeposit)
  const handleIndianPayGatewayDeposit = async (event) => {
    event.preventDefault();

    // Validate amount before proceeding
    if (!automaticAmount || automaticAmount < 100) {
      sendNotfication(
        "Please enter minimum amount 100 INR",
        "danger",
        "bottom-left"
      );
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://api.betbazaar365.com/payment/payin/create",
        {
          money: parseFloat(automaticAmount),
          uid: getUID || parseFloat(Cookies.get("uid")),
        }
      );

      const data = response?.data;

      if (!data) {
        sendNotfication(
          "Something went wrong! Please try again.",
          "danger",
          "bottom-left"
        );
        setLoading(false);
        return;
      }

      if (data?.status === false) {
        sendNotfication(
          data?.message || "Payment failed! Please try again.",
          "danger",
          "bottom-left"
        );
        setLoading(false);
        return;
      }

      console.log(data);

      if (data?.payment_link || data?.status) {
        window.open(data?.payment_link, "_blank"); // Opens in a new tab
      } else {
        sendNotfication("Payment URL is missing! Please contact support.", "danger", "bottom-left");
      }

    } catch (error) {
      console.error("Error during gateway deposit:", error);
      sendNotfication(
        "An unexpected error occurred! Please try again later.",
        "danger",
        "bottom-left"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitUtrapiHomeGatewayDeposit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        "https://api.betbazaar365.com/payment/wallet/verify/apihome",
        {
          money: parseFloat(automaticAmount),
          uid: getUID || parseFloat(Cookies.get("uid")),
          utr_number: automaticUtrNumber,
          order_id: orderId,
          mobile: mobile,
        }
      );

      const data = response?.data;

      if (!data || data?.status === false) {
        sendNotfication(
          data?.message || "Payment failed! Please try again.",
          "danger",
          "bottom-left"
        );
      } else {
        sendNotfication(data.message, "success", "bottom-left");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error during gateway deposit:", error);
      sendNotfication(error.response.data.message, "danger", "bottom-left");
    } finally {
      setLoading(false);
    }
  };

  // Modified handleProceedToPayment function
  const handleProceedToPayment = async () => {
    if (selectedPaymentMethod === "manual" && manualDepositExpanded) {
      if (!showManualPaymentForm) {
        // First click - show the manual payment form
        setShowManualPaymentForm(true);
      } else {
        // Second click - process the payment (submit functionality)
        // Validate amount first
        if (!amount || amount < 500) {
          setErrorMessage("Please enter minimum amount 500 INR");
          return;
        }

        if (!utrNumber) {
          setErrorMessage("Please enter UTR Number");
          return;
        }

        // Clear any existing error message if UTR is provided
        setErrorMessage("");

        setLoading(true);

        try {
          const response = await axios.post(
            "https://api.betbazaar365.com/payment/api/paynow/manual",
            {
              money: parseFloat(amount),
              uid: parseFloat(Cookies.get("uid")),
              utrNumber: utrNumber,
            }
          );

          const data = response?.data;

          if (!data || data?.status === false) {
            sendNotfication(
              data?.message || "Payment failed! Please try again.",
              "danger",
              "bottom-left"
            );
          } else {
            sendNotfication(data.message, "success", "bottom-left");
            // Reset form after successful submission
            setAmount("");
            setUtrNumber("");
            setErrorMessage("");
            setShowManualPaymentForm(false);
            setManualDepositExpanded(false);
          }
        } catch (error) {
          console.error("Error during gateway deposit:", error);
          sendNotfication(
            "An unexpected error occurred! Please try again later.",
            "danger",
            "bottom-left"
          );
        } finally {
          setLoading(false);
        }
      }
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setAmount(value);

    if (value === "") {
      setErrorMessage("");
      return;
    }

    if (value < 500) {
      setErrorMessage("Please enter minimum amount 500 INR");
    } else {
      setErrorMessage("");
    }
  };

  const handleAutomaticAmountChange = (e) => {
    const value = e.target.value;
    setAutomaticAmount(value);

    if (value === "") {
      setAutomaticErrorMessage("");
      return;
    }

    if (value < 100) {
      setAutomaticErrorMessage("Please enter minimum amount 100 INR");
    } else {
      setAutomaticErrorMessage("");
    }
  };

  // USDT Amount Change Handler
  const handleUsdtAmountChange = (e) => {
    const value = e.target.value;
    setUsdtAmount(value);

    if (value === "") {
      setUsdtErrorMessage("");
      return;
    }

    if (value < 1) {
      setUsdtErrorMessage("Please enter minimum amount 1 USDT");
    } else {
      setUsdtErrorMessage("");
    }
  };

  // USDT Deposit Handler
  const handleUsdtDeposit = async (event) => {
    event.preventDefault();

    // Validate amount before proceeding
    if (!usdtAmount || usdtAmount < 1) {
      sendNotfication(
        "Please enter minimum amount 1 USDT",
        "danger",
        "bottom-left"
      );
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://api.betbazaar365.com/payment/ccpayment/createDeposit",
        {
          money: parseFloat(usdtAmount),
          uid: getUID || parseFloat(Cookies.get("uid")),
        }
      );

      const data = response?.data;

      if (!data) {
        sendNotfication(
          "Something went wrong! Please try again.",
          "danger",
          "bottom-left"
        );
        setLoading(false);
        return;
      }

      if (data?.status === false) {
        sendNotfication(
          data?.message || "Payment failed! Please try again.",
          "danger",
          "bottom-left"
        );
        setLoading(false);
        return;
      }

      // Redirect to the provided web URL
      if (data?.data?.checkoutUrl) {
        window.location.href = data.data?.checkoutUrl;
      } else {
        sendNotfication(
          "Payment URL is missing! Please contact support.",
          "danger",
          "bottom-left"
        );
      }
    } catch (error) {
      console.error("Error during USDT deposit:", error);
      sendNotfication(
        "An unexpected error occurred! Please try again later.",
        "danger",
        "bottom-left"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpiGatewayToggle = () => {
    setUpiGatewayVisible(!upiGatewayVisible);
  };

  const handleUsdtGatewayToggle = () => {
    setUsdtGatewayVisible(!usdtGatewayVisible);
  };

  return (
    <div>
      <button style={style} onClick={() => setIsOpen(true)}>
        {children}
      </button>
      {isOpen && (
        <div className="popup-main-container-inner ">
          <div className="popup-main-container">
            <div className="popup-inner-box">
              {/* Header */}
              <div
                className="popup-header"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <h2
                  className="popup-title"
                  style={{ textAlign: "center", flex: 1 }}
                >
                  {activeTab}
                </h2>
                <div
                  className="popup-close-btn"
                  style={{ position: "absolute", right: "20px" }}
                  onClick={handleClose}
                >
                  ×
                </div>
              </div>

              {/* Content */}
              <div className="popup-content">
                {activeTab === "Deposit" && (
                  <div className="deposit-content">
                    {/* Currency Section */}
                    {/* Currency Section */}
                    <div className="currency-section">
                      <div className="currency-label">Deposit Currency</div>
                      <div className="currency-dropdown">
                        {selectedPaymentMethod === "usdt" ? (
                          <>
                            <img
                              className="currency-icon"
                              src="assets/images/USDT.png"
                              alt="USDT"
                              style={{ width: "20px" }}
                            />
                            <span>USDT</span>
                          </>
                        ) : (
                          <>
                            <img
                              className="currency-icon"
                              src="assets/bcimages/INR.webp"
                              alt="INR"
                            />
                            <span>INR</span>
                          </>
                        )}
                      </div>
                    </div>

                    {/* Payment Method Buttons - Updated with USDT */}
                    <div className="payment-methods-1">
                      <button
                        className={`payment-method-btn automatic ${
                          selectedPaymentMethod === "automatic"
                            ? "selected-1"
                            : ""
                        }`}
                        onClick={handleAutomaticPaymentClick}
                      >
                        Automatic Payment
                      </button>
                      <button
                        className={`payment-method-btn manual ${
                          selectedPaymentMethod === "manual" ? "selected-1" : ""
                        }`}
                        onClick={handleManualDepositToggle}
                      >
                        Manual Payment
                      </button>
                      <button
                        className={`payment-method-btn usdt ${
                          selectedPaymentMethod === "usdt" ? "selected-1" : ""
                        }`}
                        onClick={handleUsdtPaymentClick}
                      >
                        USDT Payment
                      </button>
                    </div>

                    {/* Automatic Payment Form */}
                    {selectedPaymentMethod === "automatic" &&
                      showAutomaticPaymentForm && (
                        <div
                          className="automatic-payment-form"
                          style={{ marginTop: "20px" }}
                        >
                          {isVerifyPayment ? (
                            <>
                              <div className="main-int-uew-new-1 mt-2">
                                Note: After payment Submit UTR Number
                              </div>

                              <div className="flex flex-wrap justify-center gap-6 p-6">
                                <div
                                  key={1}
                                  className="text-center p-4 border shadow-lg rounded-xl"
                                >
                                  <h2 className="text-lg font-semibold mb-2">
                                    {"UPI"}
                                  </h2>
                                  <QRCodeCanvas value={payLink} size={180} />
                                  <p className="mt-2 text-sm text-gray-600">
                                    Scan to pay via {"UPI"}
                                  </p>
                                </div>
                              </div>

                              <div className="p-2 mt-3">
                                <a
                                  href={payLink}
                                  className="submit-button-inner-main-543"
                                >
                                  Pay ₹{automaticAmount}
                                </a>
                              </div>

                              <div className="main-int-uew-new-1">
                                UTR Number:
                              </div>
                              <div className="popup-body-inner-main-543">
                                <input
                                  className="amount-input-inner-main-543 mb-3"
                                  type="number"
                                  placeholder="Enter UTR Number"
                                  value={automaticUtrNumber}
                                  onChange={(e) =>
                                    setAutomaticUtrNumber(e.target.value)
                                  }
                                />
                                <input
                                  className="amount-input-inner-main-543"
                                  type="number"
                                  placeholder="Enter mobile Number"
                                  value={mobile}
                                  onChange={(e) => setMobile(e.target.value)}
                                />
                                <button
                                  onClick={handleSubmitUtrapiHomeGatewayDeposit}
                                  className="submit-button-inner-main-543"
                                  disabled={loading}
                                >
                                  {loading ? "Processing..." : "Submit"}
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="main-int-uew-new-1">
                                100 - 50,000 INR
                              </div>
                              <div className="popup-body-inner-main-543">
                                <input
                                  className="amount-input-inner-main-543"
                                  type="number"
                                  placeholder="Enter Amount"
                                  value={automaticAmount}
                                  onChange={handleAutomaticAmountChange}
                                />
                                {/* Error Message for automatic payment */}
                                {automaticErrorMessage && (
                                  <div
                                    className="error-message"
                                    style={{
                                      color: "red",
                                      fontSize: "12px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {automaticErrorMessage}
                                  </div>
                                )}
                                <button
                                  onClick={handleIndianPayGatewayDeposit}
                                  className="submit-button-inner-main-543"
                                  disabled={
                                    loading ||
                                    !automaticAmount ||
                                    automaticAmount < 100
                                  }
                                >
                                  {loading
                                    ? "Processing..."
                                    : "Proceed to payment"}
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      )}

                    {/* USDT Payment Form */}
                    {selectedPaymentMethod === "usdt" &&
                      showUsdtPaymentForm && (
                        <div
                          className="usdt-payment-form"
                          style={{ marginTop: "20px" }}
                        >
                          <div className="main-int-uew-new-1">
                            1 - 50,000 USDT
                          </div>
                          <div className="popup-body-inner-main-543">
                            <input
                              className="amount-input-inner-main-543"
                              type="number"
                              placeholder="Enter Amount in USDT"
                              value={usdtAmount}
                              onChange={handleUsdtAmountChange}
                            />
                            {/* Error Message for USDT payment */}
                            {usdtErrorMessage && (
                              <div
                                className="error-message"
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                              >
                                {usdtErrorMessage}
                              </div>
                            )}
                            <button
                              onClick={handleUsdtDeposit}
                              className="submit-button-inner-main-543"
                              disabled={
                                loading || !usdtAmount || usdtAmount < 1
                              }
                            >
                              {loading ? "Processing..." : "Proceed to payment"}
                            </button>
                          </div>
                        </div>
                      )}

                    {/* Manual Payment Form - Shows after clicking Proceed to Payment */}
                    {selectedPaymentMethod === "manual" &&
                      manualDepositExpanded &&
                      showManualPaymentForm && (
                        <div className="manual-deposit-expanded">
                          <div className="amount-input-section">
                            <div className="input-label">
                              Enter Amount (500 - 50,000 INR)
                            </div>
                            <input
                              className="amount-input"
                              type="number"
                              placeholder="Enter Amount"
                              value={amount}
                              onChange={handleAmountChange}
                            />
                            {/* Error Message directly below amount input - only for amount errors */}
                            {errorMessage && !errorMessage.includes("UTR") && (
                              <div className="error-message">
                                {errorMessage}
                              </div>
                            )}
                          </div>

                          {/* QR Section - Now always visible when manual payment form is shown */}
                          <div className="qr-section">
                            <div className="qr-title">
                              Scan QR code and enter UTR Number
                            </div>
                            <div className="qr-image-container">
                              <img
                                className="qr-image"
                                src={`https://api.betbazaar365.com/uploads/${settings?.qr_img}`}
                                alt="QR Code"
                              />
                            </div>
                            <div className="qr-instruction">
                              Scan the QR code above to make the payment and
                              enter UTR below to confirm:
                            </div>
                            <p className="">Or</p>
                            <div>
                            <CopyableInput settings={settings}/>
                              
                            </div>

                            <div className="utr-input-section">
                              <div className="input-label">UTR Number:</div>
                              <input
                                className="amount-input"
                                type="text"
                                placeholder="Enter UTR Number"
                                value={utrNumber}
                                onChange={(e) => setUtrNumber(e.target.value)}
                              />
                              {/* Error Message for UTR Number */}
                              {errorMessage && errorMessage.includes("UTR") && (
                                <div className="error-message">
                                  {errorMessage}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                    {/* Proceed Button - Only for Manual Payment */}
                    {selectedPaymentMethod === "manual" &&
                      manualDepositExpanded && (
                        <button
                          className="proceed-btn"
                          onClick={handleProceedToPayment}
                          disabled={loading}
                        >
                          {loading
                            ? "Processing..."
                            : showManualPaymentForm
                            ? "Submit Payment"
                            : "Proceed to Payment"}
                        </button>
                      )}

                    {/* Warning Message */}
                    <div className="warning-message">
                      <div className="warning-icon">ⓘ</div>
                      <span>
                        {selectedPaymentMethod === "usdt"
                          ? "Do not deposit any currency other than USDT"
                          : "Do not deposit any currency other than INR"}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <UpiGetway
        isOpen={upiGatewayVisible}
        onClose={() => setUpiGatewayVisible(false)}
      />
      <UsdtGateway
        isOpen={usdtGatewayVisible}
        onClose={() => setUsdtGatewayVisible(false)}
      />
    </div>
  );
}

export default DepositUpi;
